/**
 * clause-editor.tsx — Soạn danh sách điều khoản (chữ thuần, không HTML) + chèn `{{biến}}`. Dùng ở Mẫu hợp đồng và Lập hợp đồng.
 */
import { ArrowDown, ArrowUp, Plus, Trash2 } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'
import { Textarea } from '@/components/ui/misc'
import { insertVariable, moveClause, type Clause } from './contract-helpers'

export function ClauseEditor({ clauses, onChange, variables }: {
  clauses: Clause[]
  onChange: (c: Clause[]) => void
  variables: Array<{ key: string; label: string }>
}) {
  const set = (i: number, patch: Partial<Clause>) => onChange(clauses.map((c, j) => (j === i ? { ...c, ...patch } : c)))
  return (
    <div className="space-y-3">
      <p className="text-xs text-muted-foreground">
        Nội dung là chữ thuần (không HTML). Bấm một biến để chèn vào cuối nội dung điều khoản; biến được thay bằng dữ liệu của hợp đồng khi gửi.
      </p>
      {clauses.map((c, i) => (
        <div key={i} className="space-y-2 rounded-md border p-3">
          <div className="flex items-center gap-2">
            <Input aria-label={`Tiêu đề điều ${i + 1}`} value={c.title} maxLength={200} placeholder="Điều … Tiêu đề" onChange={(e) => set(i, { title: e.target.value })} />
            <Button type="button" size="icon" variant="ghost" title="Lên" disabled={i === 0} onClick={() => onChange(moveClause(clauses, i, i - 1))}><ArrowUp className="h-4 w-4" /></Button>
            <Button type="button" size="icon" variant="ghost" title="Xuống" disabled={i === clauses.length - 1} onClick={() => onChange(moveClause(clauses, i, i + 1))}><ArrowDown className="h-4 w-4" /></Button>
            <Button type="button" size="icon" variant="ghost" title="Xoá điều khoản" disabled={clauses.length <= 1} onClick={() => onChange(clauses.filter((_, j) => j !== i))}><Trash2 className="h-4 w-4 text-destructive" /></Button>
          </div>
          <Textarea aria-label={`Nội dung điều ${i + 1}`} className="min-h-[90px]" maxLength={4000} value={c.text} onChange={(e) => set(i, { text: e.target.value })} />
          <div className="flex flex-wrap gap-1">
            {variables.map((v) => (
              <button
                key={v.key} type="button" title={v.label}
                className="rounded border bg-muted/40 px-1.5 py-0.5 font-mono text-[11px] text-muted-foreground hover:border-primary hover:text-primary"
                onClick={() => set(i, { text: insertVariable(c.text, v.key) })}
              >
                {`{{${v.key}}}`}
              </button>
            ))}
          </div>
        </div>
      ))}
      <Button type="button" size="sm" variant="outline" disabled={clauses.length >= 40} onClick={() => onChange([...clauses, { title: `Điều ${clauses.length + 1}. `, text: '' }])}>
        <Plus className="h-4 w-4" /> Thêm điều khoản
      </Button>
    </div>
  )
}
